//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

export const getIsDropboxImportsEnabled = createHasFeatureSelector(
  FeatureNames.DamImportDropbox,
);

export const getIsLargeVideoUploadEnabled = createHasFeatureSelector(
  FeatureNames.LargeVideoUpload,
);

export const getIsLabelManagementEnabled = createHasFeatureSelector(
  FeatureNames.LabelManagement,
);

export const getIsContentDrawerMediaRecommendationsEnabled =
  createHasFeatureSelector(FeatureNames.ContentDrawerMediaRecommendations);
